import React from "react";
import TextField from "@material-ui/core/TextField";

const renderField = ({ input, label, type, meta: { touched, error }, multiline }) => {
  const className = `form-control ${touched && error ? "is-invalid" : ""}`;

  return (
    <div className="form-group">
      <TextField
        id="filled-name"
        label={label}
        className={className}
        placeholder={label}
        margin="normal"
        variant="outlined"
        type={type}
        {...input}
        multiline={multiline}
      />
      <div className="invalid-feedback">{touched ? error : ""}</div>
    </div>
  );
};

export default renderField;



// WEBPACK FOOTER //
// ./src/components/wizardSection/renderField.jsx